import { Typography } from '@mui/material'
import LoginFrame from '@/components/LoginFrame'

interface ForgotPasswordCompleteProps {
  email: string
}

export default function ForgotPasswordComplete({
  email
}: ForgotPasswordCompleteProps) {
  return (
    <LoginFrame withLogo withBacktToLogin>
      <Typography variant='h4' sx={{ fontWeight: 600 }}>
        Check Your Email
      </Typography>
      <Typography variant='body1' color='secondary.dark' marginBottom={4}>
        {email}
      </Typography>
      <Typography variant='body1' color='textSecondary'>
        We sent you an email with a link to reset your password.
      </Typography>
      <Typography
        variant='body1'
        color='textSecondary'
        marginBottom={4}
        component={'span'}
        align='center'>
        If you can’t find it, please{' '}
        <Typography
          variant='body1'
          color='textPrimary'
          component={'span'}
          sx={{ fontWeight: 700 }}>
          check your spam folder
        </Typography>{' '}
        or{' '}
        <Typography
          variant='body1'
          color='textPrimary'
          component={'span'}
          sx={{ fontWeight: 700 }}>
          verify the email
        </Typography>
        <br />
        that you’ve provided.
      </Typography>
      <Typography variant='body1' color='textSecondary'>
        Have any issues? Please contact our operation assistants.
      </Typography>
    </LoginFrame>
  )
}
